import React from "react";
import * as _ from "lodash.debounce";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { InputAdornment, Paper } from "@mui/material";
import GetIcon from "@/components/font-awesome-icon";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";

const CustomPaper = ({ children, style, customButton }) => (
  <Paper
    style={{ ...style }}
    sx={{
      "& .MuiListSubheader-root": {
        backgroundColor: "var(--palette-container) !important",
      },
    }}
  >
    {children}
    {customButton ? customButton : null}
  </Paper>
);

const UIAutoCompelete = ({
  options,
  handleChange,
  handleTextChange = (value) => {
    console.log(value);
  },
  loading = false,
  isMultiSelectEnable,
  selected = "",
  variant = "outlined",
  title = "Select Company Key",
  styles = {},
  editable = true,
  handleBlur = null,
  name,
  required = false,
  error,
  freeSolo = false,
  placeholder = "Select one or more...",
  prefix = "",
  postfix = "",
  multiline = false,
  maxRows = 3,
  minRows,
  inputClass = "",
  errorClass = "",
  disabled = false,
  disableClearable = true,
  classes,
  size = "small",
  helperTextStyles = {},
  sx = {},
  dropdownWidth = "auto", // New prop for dropdown width
  customButton = null,
}) => {
  const handleChangeInput = (e, value, reason) => {
    console.log("reason", reason);
    if (value && reason !== "reset") handleTextChange(value);
  };

  return (
    <div className="custom-auto-comp" style={styles}>
      <Autocomplete
        // isOptionEqualToValue={}
        groupBy={(option) => option.groupByName}
        freeSolo={freeSolo}
        open={freeSolo ? false : undefined}
        onBlur={handleBlur}
        disabled={!editable || disabled}
        readOnly={!editable || disabled}
        classes={classes}
        multiple={isMultiSelectEnable}
        limitTags={editable ? 5 : undefined}
        id={name || "tags-outlined"}
        options={options}
        name={name}
        loading={loading}
        disableClearable={disableClearable}
        getOptionKey={(option, index) => option.id || option.value || index}
        getOptionLabel={(option) =>
          option.key || typeof option.label === "string"
            ? option?.label
            : "" || ""
        }
        renderOption={(props, option, state, ownerState) => {
          const { key, ...rest } = props;
          return (
            <div key={key} {...rest}>
              {option.key || option.label || ""}
            </div>
          );
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            let props = { ...getTagProps({ index }) };
            let { key, ...rest } = props;
            // set selectedopt when label is not same as value.
            // show label , not it's value
            let selectedOpt = options.find((opt) => option === opt.value);
            return (
              <Chip
                key={index}
                label={option?.key || selectedOpt?.label || option}
                {...rest}
                sx={{
                  height: "auto",
                  py: 0.2,
                  color: "var(--palette-text)",
                  backgroundColor: "var(--palette-stroke)",
                }}
                onDelete={editable ? props.onDelete : null}
                className={`${props.className} custom-chip`}
              />
            );
          })
        }
        getLimitTagsText={(more) => (
          <span className="cursor-pointer">{`+${more}`}</span>
        )}
        onChange={(e, data) => {
          handleChange(data, {
            ...e,
            target: { ...e.target, name, value: data },
          });
        }}
        sx={{
          "& .MuiInput-root": {
            "&:hover:not(.Mui-disabled, .Mui-error)::before": {
              borderBottom: "2px solid var(--palette-stroke) !important",
            },
            "&.Mui-focused::before": {
              borderBottom: "2px solid var(--palette-stroke) !important",
            },
          },

          "& ,MuiAutocomplete-endAdornment": {
            "& .MuiAutocomplete-clearIndicator": {
              "& svg": {
                color: "var(--palette-text) !important",
                fill: "var(--palette-text) !important",
              },
            },
          },
        }}
        onInputChange={_(handleChangeInput, 500)}
        value={selected || null}
        filterSelectedOptions
        PaperComponent={(props) => (
          <CustomPaper
            style={{ width: dropdownWidth }}
            {...props}
            customButton={customButton}
          />
        )} // Apply dropdown width here
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              required={required}
              variant={variant}
              error={!!error}
              helperText={error || ""}
              sx={{
                ...sx,
                background: disabled
                  ? "var(--palette-disabled_button)"
                  : "var(--palette-grid_table)",
                "& .MuiFormHelperText-root": {
                  position: "absolute",
                  bottom: "-20px",
                },
              }}
              FormHelperTextProps={{
                sx: {
                  ...helperTextStyles,
                },
              }}
              label={title + (required ? " *" : "")}
              name={name}
              inputProps={{
                ...params.inputProps,
                name,
              }}
              size={size}
              multiline={multiline}
              maxRows={maxRows}
              minRows={minRows}
              InputLabelProps={{
                style: {
                  color: error
                    ? "#d32f2f"
                    : disabled
                      ? "var(--palette-disabled_button_text)"
                      : "var(--palette-grey_text)",
                },
                shrink: params?.inputProps?.value || !!selected ? true : false,
              }}
              InputProps={{
                ...params.InputProps,
                style: {
                  color: "var(--palette-text) !important",
                  "& ,MuiAutocomplete-endAdornment": {
                    "& .MuiAutocomplete-clearIndicator svg": {
                      color: "var(--palette-text) !important",
                      fill: "var(--palette-text) !important",
                    },
                  },
                },
                startAdornment: (
                  <>
                    {prefix && (
                      <InputAdornment position="start">{prefix}</InputAdornment>
                    )}
                    {params.InputProps.startAdornment}
                  </>
                ),
                endAdornment: (
                  <>
                    {postfix && (
                      <InputAdornment
                        position="end"
                        style={{
                          position: "absolute",
                          right: 0,
                          bottom: "18px",
                          // color: "var(--palette-text)",
                        }}
                      >
                        {postfix}
                      </InputAdornment>
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          );
        }}
        popupIcon={
          <GetIcon
            icon={faChevronDown}
            iconStyles={{
              marginRight: 0,
              fontSize: "0.625rem",
              color: "var(--palette-text)",
            }}
          />
        }
        slotProps={{
          popper: {
            sx: {
              "& .MuiAutocomplete-groupUl .MuiAutocomplete-option:hover": {
                backgroundColor:
                  "var(--palette-secondary_button_hover) !important",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default UIAutoCompelete;
